export const RULES_QUERY_KEY = 'rules';
